import axios from "../../../../api/axios";

import { Group, GroupFormData } from "../types/group.types";

export const getGroups = async (entityId: number | null | undefined): Promise<Group[]> => {
  if (!entityId) {
    return [];
  }
  const { data } = await axios.get(`/api/${entityId}/groups`);
  return data;
};

export const createGroup = async (entityId: number, groupData: GroupFormData): Promise<Group> => {
  const { data } = await axios.post(`/api/${entityId}/groups`, groupData);
  return data;
};

export const getGroupDetails = async (entityId: number, groupId: number): Promise<Group> => {
  const { data } = await axios.get(`/api/${entityId}/groups/${groupId}`);
  return data;
};

export const updateGroup = async (entityId: number, groupId: number, groupData: GroupFormData): Promise<Group> => {
  const { data } = await axios.put(`/api/${entityId}/groups/${groupId}`, groupData);
  return data;
};
